import axios from "axios";
import * as Sentry from "@sentry/nextjs";
import config from "@/config";
import configClient from "@/config.client";
import { MutualConnectionsModel } from "@/types/Connections";

class ConnectionsClient {
  private apiEndpoint: string;

  constructor() {
    this.apiEndpoint =
      config.ALLBRIGHT_API_URL || configClient.ALLBRIGHT_API_URL;
  }

  private async _getMutualConnections(
    userId: string
  ): Promise<MutualConnectionsModel[]> {
    try {
      const url = `${this.apiEndpoint}/v1/connections/mutual/${userId}`;
      const response = await axios.get<MutualConnectionsModel[]>(url);

      return response.data;
    } catch (err) {
      Sentry.captureException(err.response || err);
      throw new Error(err.message);
    }
  }

  public async getUserMutualConnections(
    userId: string
  ): Promise<MutualConnectionsModel[]> {
    try {
      const data = await this._getMutualConnections(userId);

      return data;
    } catch (error) {
      Sentry.captureException(
        new Error(`Error fetching mutual connections data: ${error.message}`)
      );
      return [];
    }
  }
}

export default ConnectionsClient;
